import React from "react";
import { FeatureModule } from "@/shared/types/routing";
import { MyAccountIcon } from "@/shared/ui/icons";

const CustomerFeedback = React.lazy(() => import("./CustomerFeedback"));
const DoorStepService = React.lazy(() => import("./DoorStepService"));
const PaymentGatewayReturn = React.lazy(() => import("./PaymentGatewayReturn"));
const PaymentGatewayFail = React.lazy(() => import("./PaymentGatewayFail"));
const PaymentGatewayPending = React.lazy(() => import("./PaymentGatewayPending"));

const PublicFormsModule: FeatureModule = {
    name: "public-forms",
    routes: [
        {
            path: "/customer-feedback",
            element: <CustomerFeedback />,
            meta: {
                label: "Customer Feedback",
                icon: MyAccountIcon,
                showInSidebar: false,
                requiresAuth: false,
            },
        },
        {
            path: "/door-step-service",
            element: <DoorStepService />,
            meta: {
                label: "Door Step Service",
                icon: MyAccountIcon,
                showInSidebar: false,
                requiresAuth: false,
            },
        },
        {
            path: "/payment/return",
            element: <PaymentGatewayReturn />,
            meta: {
                label: "booking:payment.gatewayReturnTitle",
                icon: MyAccountIcon,
                showInSidebar: false,
                allowGuestAndAuth: true,
                noSidebar: true,
            },
        },
        {
            path: "/payment/fail",
            element: <PaymentGatewayFail />,
            meta: {
                label: "booking:payment.gatewayFailTitle",
                icon: MyAccountIcon,
                showInSidebar: false,
                allowGuestAndAuth: true,
                noSidebar: true,
            },
        },
        {
            path: "/payment/pending",
            element: <PaymentGatewayPending />,
            meta: {
                label: "booking:payment.gatewayPendingTitle",
                icon: MyAccountIcon,
                showInSidebar: false,
                allowGuestAndAuth: true,
                noSidebar: true,
            },
        },
    ],
};

export default PublicFormsModule;
